import { render, staticRenderFns } from "./DiscountCouponsPage.vue?vue&type=template&id=6f2ea212"
import script from "./DiscountCouponsPage.vue?vue&type=script&lang=js"
export * from "./DiscountCouponsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports